import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCurrentUser, useAccessToken } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { InfoUser } from '@/types/user'

interface CreateAdminParams {
  info_user: InfoUser
}

export function useCreateUsuarioAdmin() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ info_user }: CreateAdminParams) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        name: info_user.name,
        password: info_user.password,
        cpf: info_user.cpf,
        email: info_user.email,
        whatsApp: info_user.whatsApp,
        typeCargo: info_user.typeCargo,
        typeUser: info_user.typeUser
      }

      const response = await api.post(`/user/create-user-admin`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) return response.data
      throw new Error('Erro ao criar usuário admin')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] })
    }
  })
}
